import type { PortableTextBlock } from 'sanity';
import type { PageSeo } from '@pkg/sanity-utils/types/seo';

import type { SurpriseBag } from '@pkg/types/surpriseBag';

export const BRAND_PLACEHOLDER = '$' + '{brand}';
export const CITY_PLACEHOLDER = '$' + '{city}';

export interface BrandProfileLink {
  name: string;
  profileSlug: string;
  language: string;
}

export interface SurpriseBagByIdResponse {
  success: boolean;
  payload?: SurpriseBag;
  brandProfileLink?: BrandProfileLink | null;
}

export interface BrandProfileSanityImage {
  url?: string | null;
  alt?: string | null;
}

export interface BrandProfileDefaultTextsPortable {
  brandDefaultDescription?: PortableTextBlock[] | null;
  cityDefaultDescription?: PortableTextBlock[] | null;
  savedCo2Label?: string | null;
  mealsSavedLabel?: string | null;
  citiesListTitle?: string | null;
  noCitiesAvailableText?: string | null;
  surpriseBagsListTitle?: string | null;
  defaultSeoSocial?: PageSeo | null;
}

export interface BrandProfileSanityDoc {
  _type?: string;
  name?: string;
  pageTitle?: string;
  chainId?: string;
  showRatings?: boolean | null;
  showSavedCo2?: boolean | null;
  showMealsSaved?: boolean | null;
  description?: PortableTextBlock[];
  brandProfileDefaultTexts?: BrandProfileDefaultTextsPortable | null;
  seoSocial?: PageSeo | null;
  profileSlug?: string;
  heroImage?: BrandProfileSanityImage | null;
  logo?: BrandProfileSanityImage | null;
}

export interface BrandProfileMarketingDoc {
  mealsSaved?: number;
  item?: {
    item?: {
      coverPicture?: { currentUrl?: string };
      logoPicture?: { currentUrl?: string };
    };
  };
  chainRating?: number;
  co2EquivalentKg?: number;
}

export interface BrandProfileItemsResponse {
  items: Array<Record<string, unknown>>;
  paging: {
    page: number;
    size: number;
    totalElements: number;
  };
}
